var _rect, _ellipse, _path, _path2, _path3, _path4, _path5, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.848,
    cy: 124.362,
    rx: 52.2205,
    ry: 23.3618,
    fill: "#1C1B1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.474 144.976V193.073C265.39 216.893 247.433 260.685 168.278 245.294C147.206 239.797 105.888 217.26 109.186 171.086",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M265.881 144.976V193.073C264.964 216.893 282.921 260.685 362.076 245.294C383.148 239.797 424.466 217.26 421.168 171.086",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.329 427.471C195.305 420.736 195.822 311.064 207.833 257.07C244.742 246.832 262.276 217.556 266.429 204.198C268.315 232.217 304.708 251.12 322.669 257.07C307.582 283.741 328.955 309.043 341.527 318.36C374.395 342.338 374.82 359.445 375.54 372.916C378.234 423.295 319.189 430.277 289.329 427.471Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M266.804 212.28C260.519 243.995 248.238 313.653 292.503 364.16",
    stroke: "#1C1B1F",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M349.565 333.004C351.176 333.059 352.735 334.095 354.222 334.278C355.742 335.273 355.796 336.305 357.085 337.572C358.429 338.892 357.308 340.345 358.447 341.589C359 342.192 359.671 343.872 359.816 344.655C359.923 345.234 360.017 346.913 360.368 347.343C361.845 349.158 359.283 352.104 360.056 354.229C360.855 356.428 362 358.928 362 361.257C362 364.253 360.03 366.866 359.383 369.724C359.038 371.251 356.796 373.78 355.326 374.605C352.789 376.03 349.756 376.24 346.684 375.785C343.851 375.364 341.861 374.202 339.291 373.12C338.198 372.66 337.423 371.977 336.53 371.209C335.733 370.524 336.044 369.853 335.546 369.181C334.771 368.134 334.616 366.354 334.322 365.054C334.005 363.652 332.736 362.233 331.753 361.21C329.79 359.168 327.323 355.743 327.432 352.862C327.487 351.415 328.453 349.889 328.08 348.499C327.761 347.306 327 346.346 327 345.103C327 341.85 329.751 340.691 331.969 338.947C333.722 337.57 335.19 335.792 337.13 334.702C339.553 333.342 342.068 333.429 344.884 333.429C346.437 333.429 347.929 332.949 349.565 333.004Z",
    fill: "#D9D9D9",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.137,
    cy: 407.042,
    rx: 4.71466,
    ry: 3.90821,
    fill: "#1C1B1F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.874,
    cy: 406.484,
    rx: 1.73698,
    ry: 1.48884,
    fill: "#D9D9D9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.947,
    cy: 387.148,
    rx: 4.71466,
    ry: 3.90821,
    fill: "#1C1B1F"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 305.684,
    cy: 386.589,
    rx: 1.73698,
    ry: 1.48884,
    fill: "#D9D9D9"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.593,
    cy: 385.905,
    rx: 4.71466,
    ry: 3.90821,
    fill: "#1C1B1F"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.33,
    cy: 385.346,
    rx: 1.73698,
    ry: 1.48884,
    fill: "#D9D9D9"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.323,
    cy: 405.799,
    rx: 4.71466,
    ry: 3.90821,
    fill: "#1C1B1F"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.06,
    cy: 405.24,
    rx: 1.73698,
    ry: 1.48884,
    fill: "#D9D9D9"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 340.004,
    cy: 400.825,
    rx: 4.71466,
    ry: 3.90821,
    fill: "#1C1B1F"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 341.741,
    cy: 400.267,
    rx: 1.73698,
    ry: 1.48884,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/치과_구내염.ac0f16d949b92feb68ead66bb96ed0b1.svg";
export { ForwardRef as ReactComponent };